import apiSlice from "../api/apiSlice";

export const evApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getEVBatteryStateLoadsByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        startDate,
        endDate,
        time,
        resourceId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/ev_battery_state_loads/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${!date && startDate ? `&start_date=${startDate}` : ""}` +
          `${!date && endDate ? `&end_date=${endDate}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "EV", id: "LIST" }],
    }),
    getEVChargingIntervalsForecastByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        startDate,
        endDate,
        time,
        resourceId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/ev_charging_intervals_forecast/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${!date && startDate ? `&start_date=${startDate}` : ""}` +
          `${!date && endDate ? `&end_date=${endDate}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "EV", id: "LIST" }],
    }),
    getEVDrivingLoadsByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        startDate,
        endDate,
        time,
        resourceId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/ev_driving_loads/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${!date && startDate ? `&start_date=${startDate}` : ""}` +
          `${!date && endDate ? `&end_date=${endDate}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "EV", id: "LIST" }],
    }),
    /* POST */
    addEVBatteryStateLoads: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/ev_battery_state_loads`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EV", id: "LIST" }],
    }),
    addEVChargingIntervalsForecast: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/ev_charging_intervals_forecast`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EV", id: "LIST" }],
    }),
    addEVDrivingLoads: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/ev_driving_loads`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EV", id: "LIST" }],
    }),
  }),
});

export const {
  useAddEVBatteryStateLoadsMutation,
  useAddEVChargingIntervalsForecastMutation,
  useAddEVDrivingLoadsMutation,
  useGetEVBatteryStateLoadsByCommunityIdPaginationQuery,
  useGetEVChargingIntervalsForecastByCommunityIdPaginationQuery,
  useGetEVDrivingLoadsByCommunityIdPaginationQuery,
} = evApiSlice;
